import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { AlertComponent } from 'src/app/shared/alert/alert.component';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user/user.service';
import { AreaService } from 'src/app/services/Area/area.service';


@Component({
  selector: 'app-select-datetime',
  templateUrl: './select-datetime.page.html',
  styleUrls: ['./select-datetime.page.scss'],
})
export class SelectDatetimePage implements OnInit {
  favoriteSeason: string;
  dates:any=[];
  selectedDate:any;
  CheckInTime:any;
  selectedHours:any = 12;
  seasonsIn = [
    {show:'9-10 AM',hours:9},
    {show:'10-12 AM',hours:10},
    {show:'12-2 PM',hours:12},
    {show:'2-4 PM',hours:14},
    {show:'4-6 PM',hours:16},
    {show:'6-8 PM',hours:18},
  ];
  constructor(
    private navCtrl:NavController,
    private alert:AlertComponent,
    private r:Router,
    private userservice:UserService,
    private areaService:AreaService

  ) {
  
   
   }

   checkTimings(){
     console.log(new Date(this.selectedDate).getDate())
    if(new Date(this.selectedDate).getDate() > new Date().getDate()){
      console.log("full");
      this.seasonsIn = [
        {show:'9-10 AM',hours:9},
        {show:'10-12 AM',hours:10},
        {show:'12-2 PM',hours:12},
        {show:'2-4 PM',hours:14},
        {show:'4-6 PM',hours:16},
        {show:'6-8 PM',hours:18},
      ];
      setTimeout(() => {
        this.CheckInTime = this.seasonsIn[0].hours;
      }, 50);
    }else{
      for(let i=0;i<this.seasonsIn.length;i++){
        if(this.seasonsIn[i].hours < new Date().getHours() + 2){
          this.seasonsIn.splice(i,1);
          i = i -1;
        }
      }
      setTimeout(() => {
        this.CheckInTime = this.seasonsIn[0].hours;
      }, 50);


      console.log("notfull")
    }
   }
   goback(){
		this.navCtrl.navigateBack('/service-detail');
    }
    
    ionViewDidEnter(){
  this.areaService.showHome=false  

      let data = JSON.parse(localStorage.getItem('JobData'));
      if(data.CheckInTime && data.CheckOutTime){
        this.CheckInTime = data.CheckInTime;
        this.selectedDate = data.date;
      }
      if(data.dates){
        this.dates = data.dates;
      }else{
        let currentDate;
        currentDate = new Date();
        for(let i =0;i<7;i++){
          var newdate = new Date(currentDate);
          newdate.setDate(newdate.getDate() + i);
          this.dateFormat(newdate);
          if(i == 0){
            this.selectedDate = newdate;
          }
          if(i == 3){
            console.log(this.dates);
          }
        }
      }

      for(let i=0;i<this.seasonsIn.length;i++){
        if(this.seasonsIn[i].hours < new Date().getHours() + 2){
          this.seasonsIn.splice(i,1);
          i = i -1;
        }
      }

      setTimeout(() => {
        if (this.seasonsIn.length > 0){
          this.CheckInTime = this.seasonsIn[0].hours;
        }else{
          this.dates =[];
          if(data.CheckInTime && data.CheckOutTime){
            this.CheckInTime = data.CheckInTime;
            this.selectedDate = data.date;
          }
          if(data.dates){
            this.dates = data.dates;
          }else{
            let currentDate;
            currentDate = new Date();
            for(let i =1;i<8;i++){
              var newdate = new Date(currentDate);
              newdate.setDate(newdate.getDate() + i);
              this.dateFormat(newdate);
              if(i == 0){
                this.selectedDate = newdate;
              }
              if(i == 3){
                console.log(this.dates);
              }
            }
          }
          this.seasonsIn = [
            {show:'9-10 AM',hours:9},
            {show:'10-12 AM',hours:10},
            {show:'12-2 PM',hours:12},
            {show:'2-4 PM',hours:14},
            {show:'4-6 PM',hours:16},
            {show:'6-8 PM',hours:18},
          ];
          setTimeout(() => {
            this.CheckInTime = this.seasonsIn[0].hours;
            this.selectedDate = this.dates[0].fulldate;

          }, 50);
        }
      }, 50);
    }


   dateFormat(date:Date){
    let dat:any = date.getDate();
    const monthNames = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    const thisMonth = monthNames[date.getMonth()];
    if(dat < 10){
      dat = '0' + dat;
    }
    let arr = {"date":dat,"month":thisMonth,"fulldate":date}
    this.dates.push(arr);    
   }

  ngOnInit() {
  }

nextPage(){
  if(this.selectedDate){
    if(this.CheckInTime){   
      let timeIn ;
      this.seasonsIn.map((ele)=>{
        if(ele.hours == this.CheckInTime){
          timeIn = ele.show
        }
      })
      setTimeout(() => {
        
        let data = JSON.parse(localStorage.getItem('JobData'));
        console.log(data);
        data.date = this.selectedDate;
        data.timeIn = timeIn;
        data.dates = this.dates;
        data.CheckInTime = this.CheckInTime;
        localStorage.setItem('JobData',JSON.stringify(data));
        if(JSON.parse(localStorage.getItem('userProfile'))){
          this.navCtrl.navigateForward("/address_multiple");
        }else{
          this.alert.presentAlertConfirm("You have to login to proceed","Not Now","Login").then((res)=>{
            if(res['role'] == 'cancel' ){
              console.log("cancel");
            }else{
              this.userservice.navigationdata = {"login":"routing",
              "redirectto":"/select-datetime"};
              this.navCtrl.navigateForward('/login');
              }
            });
        }
      }, 200);
                    

    }else{
      this.alert.presentAlert("Information","Please Select a In Time");
    }
  }else{
    this.alert.presentAlert("Information","Please Select a Date");
  }
}

}
